(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/quickplay/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/quickplay/pay.js');

'use strict';

class PayQuickplay extends svs.tur.payment.api.jupiter.base.PayBase {
  constructor(_ref) {
    let {
      betContainer,
      productName,
      price
    } = _ref;
    const wagerModel = new (Backbone.Model.extend({
      defaults: {
        productId: productName,
        price,
        isPackage: true
      }
    }))();
    super({
      wagerModel
    });
    this.productName = productName;
    this.price = price;
    this.payableObj = betContainer;
    this.fetchUrls.push("/draw/1/".concat(svs.numbergames.productMapping.getProductDrawId(productName), "/draws"));
  }
  showConfirmDialog() {
    this.onPayConfirm();
  }

  sendAnalytics(_ref2) {
    let {
      wagerId,
      betsObj
    } = _ref2;
    new svs.tur.payment.api.jupiter.quickplay.services.Analytics({
      betsObj,
      wagerId,
      wagerModel: this.wagerModel
    });
  }
}
svs.tur.payment.api.jupiter.quickplay.Pay = PayQuickplay;

 })(window);